import React, { useEffect } from 'react'
import * as Sentry from '@sentry/browser'
import { useLocation } from 'react-router'

import { useBanner } from 'containers/Banner'
import VerifyBanner, { VERIFY_BANNER_ID } from 'components/VerifyBanner'

import useUserProfile from 'modules/user/useUserProfile'
import useUserSignedIn from 'modules/user/useUserSignedIn'

const UserContext = () => {
  const { showBanner } = useBanner()
  const isSignedIn = useUserSignedIn()
  const { pathname } = useLocation()

  const { data } = useUserProfile(false, {
    skip: !isSignedIn,
  })

  const user = data?.me

  /* Update the sentry context */
  useEffect(() => {
    const { identifier, name } = user || {}

    Sentry.configureScope(scope => {
      scope.setUser(identifier && name ? { identifier, name } : null)
    })
  }, [user])

  /* Show the verified banner if needed */
  useEffect(() => {
    if (user?.isVerified === false) {
      const { dismissBanner } = showBanner({
        id: VERIFY_BANNER_ID,
        message: <VerifyBanner userEmail={user.email!} />,
      })

      return () => {
        dismissBanner()
      }
    }
  }, [showBanner, user, pathname])

  return null
}

export default UserContext
